import { useCallback, useEffect } from 'react';

// do whatever you want when there is a resize event
const useResize = (onResize: () => void): void => {
  const handleResize = useCallback(() => {
    onResize();
  }, [onResize]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);
};

export default useResize;
